import { useState } from "react";
import { SalarioInputCard } from "./components/SalarioInputCard";
import { SalarioResponseCard } from "./components/SalarioResponseCard";
import type { SalarioResultsType } from "./types";

export default function CalculadoraSalarioRealidadeBrasileira() {
  const [results, setResults] = useState<SalarioResultsType | null>(null);

  return (
    <>
      <SalarioInputCard setResults={setResults} />
      {results && <SalarioResponseCard results={results} />}
    </>
  );
}